'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$() {
  this.aCO = null;
  this.aCP = false;
}
export { $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$ as $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$ };
$p = $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$;
/** @constructor */
function $h_Lapp_data_OrganizationEmail$package$OrganizationEmail$() {
}
export { $h_Lapp_data_OrganizationEmail$package$OrganizationEmail$ as $h_Lapp_data_OrganizationEmail$package$OrganizationEmail$ };
$h_Lapp_data_OrganizationEmail$package$OrganizationEmail$.prototype = $p;
$p.aA = (function() {
  if ((!this.aCP)) {
    this.aCO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aCP = true;
  }
  return this.aCO;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_OrganizationEmail$package$OrganizationEmail$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationEmail$package$OrganizationEmail$, "app.data.OrganizationEmail$package$OrganizationEmail$", ({
  Eg: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_OrganizationEmail$package$OrganizationEmail$ as $d_Lapp_data_OrganizationEmail$package$OrganizationEmail$ };
var $n_Lapp_data_OrganizationEmail$package$OrganizationEmail$;
function $m_Lapp_data_OrganizationEmail$package$OrganizationEmail$() {
  if ((!$n_Lapp_data_OrganizationEmail$package$OrganizationEmail$)) {
    $n_Lapp_data_OrganizationEmail$package$OrganizationEmail$ = new $c_Lapp_data_OrganizationEmail$package$OrganizationEmail$();
  }
  return $n_Lapp_data_OrganizationEmail$package$OrganizationEmail$;
}
export { $m_Lapp_data_OrganizationEmail$package$OrganizationEmail$ as $m_Lapp_data_OrganizationEmail$package$OrganizationEmail$ };
//# sourceMappingURL=app.data.-Organization-Email$package$-Organization-Email$.js.map
